import { useQuery } from '@tanstack/react-query';
import { type WholesaleRevenueBreakdownParams, type WholesaleRevenueBreakdownItem, fetchWholesaleRevenueBreakdown } from '../services/wholesaleRevenueBreakdownService';

export function useWholesaleRevenueBreakdown(params: WholesaleRevenueBreakdownParams) {
  return useQuery<WholesaleRevenueBreakdownItem[], Error>({
    queryKey: ['wholesale-revenueBreakdown', params],
    queryFn: () => fetchWholesaleRevenueBreakdown(params),
    staleTime: 1000 * 60 * 5,
    enabled: !!params.start_date && !!params.end_date,
  });
}
